<ng-template #login>
  <h1>TSync</h1>

  <a class="btn btn-warning" [href]="bexioSettings?.grantUrl">
    <fa-icon icon="sign-in"></fa-icon> Connexion
  </a>
</ng-template>
